import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@mui/material';
import Typography from '@mui/material/Typography';
import { connect } from 'react-redux';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AddRecourcesGroup from './AddRecourcesGroup';
import Table from '../common/TableMultiCheckbox';
import { checkPrivileges, selectAll } from '../../Helpers';

const a11yProps = (index) => {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
};

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{ color: 'inherit', ...other.style }}
        >
            {children}
        </Typography>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const MainUnitModal = (props) => {
    const {handleTabChangeMainUnitModal}=props
    const currentTab=props.mainunitModalTab|| 'basic';
    const orientation = window.innerWidth <= 959 ? 'horizontal' : 'vertical';

    return (
        <Fragment>
            <h4 className="tab-title">{props.selectedResourse?.name ||'Groups'}</h4>
            <div className={'main-unit-modal-bg clearfix'} style={{ display: 'flex' }}>
                <div style={{ maxWidth: 264, minWidth: 220,height:"80vh",borderRight:"1px solid rgba(0, 0, 0, 0.12"}}>
                    <Tabs
                        orientation={orientation}
                        variant='scrollable'
                        scrollButtons='auto'
                        value={currentTab}
                        onChange={handleTabChangeMainUnitModal}
                        aria-label='Vertical tabs example'
                        className='custom-tabs'
                        textColor='#FFFFFF'
                        style={{borderRight:0}}
                        TabIndicatorProps={{ hidden: true }}
                    >
                        <Tab
                            value="basic"
                            classes={{
                                root: 'common-tab',
                                selected: 'tab-selected',
                                wrapper: 'tab-wrapper'
                            }}
                            label={
                                <span className="menu_item_text">
                                    {props.translate('basic')} <ArrowRightIcon className="tab_menu_icon" />
                                </span>
                            }
                            {...a11yProps('basic')}
                        />
                        <Tab
                            value="groupTable"
                            classes={{
                                root: 'common-tab',
                                selected: 'tab-selected',
                                wrapper: 'tab-wrapper',
                            }}
                            label={
                                <span className="menu_item_text">
                                    {props.translate('Assign List')} <ArrowRightIcon className="tab_menu_icon" />
                                </span>
                            }
                            {...a11yProps(1)}
                        />
                    </Tabs>
                </div>

                {currentTab === 'basic' && (
                    <TabPanel value={currentTab} index={'basic'} style={{ width: '100%' }} >
                        {['addResource', 'editResource'].includes(props.activeOperation) && (
                            <AddRecourcesGroup
                                isCreate={props.isCreate}
                                isVisableUserBtn={props.isVisableUserBtn}
                                form={props.form}
                                processing={props.processing}
                                rowsPerPage={props.rowsPerPage}
                                title={props.title}
                                itemType={props.itemType}
                                handleChange={props.handleChange}
                                formSubmit={props.formSubmit}
                                onClose={props.onCloseResource}
                            />
                        )}
                    </TabPanel>
                )}

                {currentTab === 'groupTable' && (
                    <TabPanel value={currentTab} index={'groupTable'} style={{ width: '100%' }}>
                        {props.linkResource && (
                            <Table
                                rows={props.itemData || []}
                                title={props.processing || props.nestedResources.loading ? props.translate('sharedLoading') : props.itemType}
                                checkHandleChange={props.checkHandleChange}
                                handleChangeRowsPerPage={props.handleChangeRowsPerPage}
                                searchable
                                // insideDialog
                                // isEditable
                                selectAll={e =>
                                    selectAll(
                                        e,
                                        'itemgroupid',
                                        'itemid',
                                        props.selectedResourse.id,
                                        props.itemData,
                                        props.itemData,
                                        props.dispatch,
                                        'abc',
                                        props.translate,
                                        props.onChange
                                    )
                                }
                                disableHead
                                showCheckbox
                                rowsPerPage={props.rowsPerPage}
                                canRemove={checkPrivileges('itemgroupUnlinkItem')}
                                canAssign={checkPrivileges('itemgroupLinkItem')}
                                rowDefinition={props.rowDefinition}
                            />
                        )}
                    </TabPanel>
                )}
            </div>
        </Fragment>
    );
};

MainUnitModal.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
    devices3: state.devices3,
    devices: state.devices,
    groups: state.groups,
    drivers: state.drivers,
    themecolors: state.themeColors,
    selecteddevices: state.selecteddevices,
    logInUsers: state.logInUsers,
});

const mapStateToProps = connect(mapState);

export default mapStateToProps((MainUnitModal));